import * as React from 'react';
import './App.css';

import * as product_list from './assets/config/products.json';

import * as back_photo from './assets/img/background.png';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Main from './main/main.component';
import Checkout from './checkout/checkout.component';

import Nav from './nav/nav.component';
import Pricing from './pricing/pricing.component';
// import Features from './features/features.component';
// import About from './about/about.component';
import { StoreState, CustomAction } from './store';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { replaceGeneric } from './store/actions/generic.actions';
import Footer from './footer/footer.component';

export interface App_Props {
  route: string;

  replaceItems: Function;
}

class App extends React.Component<App_Props> {

  constructor(props: any) {
    super(props)
    this.props.replaceItems('PRODUCT_LIST_REPLACE', product_list)
  }

  public render() {
    return (
      <Router>
        <div className="App">
          <Nav></Nav>
          <div className="app-graphics">
            <img src={back_photo} className="app-graphics-background" alt="background" />
            {/* a person holding an umbrella under a rain of data (leave, clocks, letters)*/}
          </div>
          <Route render={({ location }) => (
            <TransitionGroup>
              <CSSTransition key={location.key} classNames="navigate" timeout={500}>
                <Switch location={location}>
                  <Route exact path="/" component={Main} />
                  {/* <Route path="/features" component={Features} /> */}
                  <Route path="/pricing" component={Pricing} />
                  {/* <Route path="/about" component={About} /> */}
                  <Route path="/signup" component={Checkout} />
                </Switch>
              </CSSTransition>
            </TransitionGroup>
          )} />
          <Footer></Footer>
        </div>
      </Router>
    );
  }
}

export function mapStateToProps({ route }: StoreState) {
  return {
    route: route,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
  return bindActionCreators({
    replaceItems: replaceGeneric
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.tsx